import {afterDomIsReady} from './utils/whenLoaded';

export function initializePageLeaveConfirmation(): void
{
	afterDomIsReady(() => {
		const el = document.getElementById('nextPatient');
		if (el === null) {
			return;
		}

		el.addEventListener('click', ev => {
			if ( ! window.confirm(el.dataset.confirmationLabel)) {
				ev.preventDefault();
			}
		});
	});
}
